import { withStyles } from "@material-ui/core/styles";
import Saldo from "./Saldo";
import styles from "./styles";

export default withStyles(styles)(Saldo);
